export default {
  name: 'marking--aggrP',
  apiService: 'shoes',
  apiPath: '/admin/aggr_p',
};